module.exports = __webpack_public_path__ + "img/brandguide_story.c8a00537.jpg";